import { Toast, ToastType } from '@everlywell/leaves';
import React, { useEffect } from 'react';
import { NotificationType } from 'utils/types';

import { CLEAR_NOTIFICATION_DELAY } from '../../containers/Notification';
import analytics from '../../utils/analytics';
import { ANALYTICS } from '../../utils/constants/analytics';
import { TOAST_NOTIFICATION } from '../../utils/constants/dataTest';
import * as S from './styles';

type Props = {
  notification?: NotificationType;
  clearNotification?: () => void;
};

const getLabelFromNotification = (notification: NotificationType) => {
  if (notification.mixpanelLabel) return notification.mixpanelLabel;
  return (notification.details ?? notification.message) as string;
};

function ToastNotification(props: Props): JSX.Element | null {
  const { notification, clearNotification } = props;
  const type = notification?.type ?? ToastType.SUCCESS;
  const persistent = notification?.persist ?? false;
  const handleClearNotification = () => {
    if (clearNotification) {
      analytics.track({
        event: ANALYTICS.EVENTS.CLEAR_NOTIFICATION,
        data: {
          label: ANALYTICS.LABELS.NOTIFICATION,
          type,
          category: ANALYTICS.CATEGORIES.NOTIFICATION,
          component: ANALYTICS.CATEGORIES.NOTIFICATION,
        },
      });
      clearNotification();
    }
  };

  useEffect(() => {
    if (notification) {
      analytics.track({
        event: ANALYTICS.EVENTS.NOTIFICATION,
        data: {
          label: getLabelFromNotification(notification),
          type: notification.type,
          category: ANALYTICS.CATEGORIES.NOTIFICATION,
          component: notification.source,
        },
      });
    }
  }, []);
  const message = notification?.message ?? '';
  const details = notification?.details;
  return notification ? (
    <S.Wrapper
      data-testid={
        notification.type === ToastType.SUCCESS
          ? TOAST_NOTIFICATION.INFO_NOTIFICATION
          : TOAST_NOTIFICATION.ERROR_NOTIFICATION
      }
    >
      <Toast
        type={type}
        content={message}
        subtext={details}
        handleClose={handleClearNotification}
        visibleTime={CLEAR_NOTIFICATION_DELAY - 500}
        persistent={persistent}
      />
    </S.Wrapper>
  ) : null;
}

export default ToastNotification;
